const ErrorPage = () => {
    return ( 
    <div className="error-page">
        what the heck are you doing? This page doesn't even exist!
    </div> );
}
 
export default ErrorPage;